module.exports = __webpack_public_path__ + "static/media/DoneApp.27368f66.svg";